import TutorReplacementPage from './TutorReplacementPage';

// Tutor Replacement Count, by replaced tutor (the page and its rules: TutorReplacementPage.jsx).
const TutorReplacementByTutorDashboard = () => <TutorReplacementPage mode="tutor" />;

export default TutorReplacementByTutorDashboard;
